<style scoped>
.br-10 {
  padding: 10px;
  border-radius: 10px;
}
.border {
  padding: 10px;
  border: 1px solid grey;
  border-radius: 5px;
}
</style>

<template>
  <v-container fluid fill-height row>
    <v-layout justify-center align-start>
      <v-flex lg8 sm10 xs12>
        <v-stepper v-model="stepnow" vertical class="br-10">
          <v-card flat class="text-center transparent pa-2">
            <span class="title primary--text text--darken-2"><strong>{{ $t('trading_license_application') }}</strong></span>
          </v-card>

          <!-- application -->
          <v-stepper-step :complete="stepnow > 1" step="1" @click.native="stepnow = 1">
            {{ $t('applicant_information') }}
          </v-stepper-step>

          <v-stepper-content step="1">
            <v-card class="mb-12" flat>
              <v-text-field clearable name="name" :value="data.applicant.name" :label="$t('name')" @input="patchApplicant({ applicant: { name: $event } })" v-validate="'required'" :error-messages="errors.collect('name')" :data-vv-as="$t('name')" required type="text"></v-text-field>
              <v-select clearable name="identity_type" :value="data.applicant.identity_type" :label="$t('identity_type')"  @input="patchApplicant({ applicant: { identity_type: $event } })" :items="identity_type" :item-text="opt => $t(opt.value)" :item-value="opt => opt.value" v-validate="'required'" :error-messages="errors.collect('identity_type')" :data-vv-as="$t('identity_type')"></v-select>
              <v-text-field clearable name="identity_no" :value="data.applicant.identity_no" :label="$t('identity_no')" @input="patchApplicant({ applicant: { identity_no: $event } })" v-validate="'required'" :error-messages="errors.collect('identity_no')" :data-vv-as="$t('identity_no')" required type="text"></v-text-field>
              <v-text-field clearable name="phone" :value="data.applicant.phone" :label="$t('phone')"  @input="patchApplicant({ applicant: { phone: $event } })" v-validate="'required'" :error-messages="errors.collect('phone')" :data-vv-as="$t('phone')" type="tel" required></v-text-field>
              <v-text-field clearable name="email" :value="data.applicant.email" :label="$t('email')"  @input="patchApplicant({ applicant: { email: $event } })" v-validate="'required|email'" :error-messages="errors.collect('email')" :data-vv-as="$t('email')" type="email" required></v-text-field>
              <v-textarea clearable name="address" :value="data.applicant.address" :label="$t('address')"  @input="patchApplicant({ applicant: { address: $event } })" v-validate="'required'" :error-messages="errors.collect('address')" :data-vv-as="$t('address')" type="text" required></v-textarea>
              <v-select clearable name="state" :value="data.applicant.state" :label="$t('state')"  @input="patchApplicant({ applicant: { state: $event } })" :items="states" :item-text="opt => opt" :item-value="opt => opt" v-validate="'required'" :error-messages="errors.collect('state')" :data-vv-as="$t('state')"></v-select>
              <v-text-field clearable name="postcode" :value="data.applicant.postcode" :label="$t('postcode')" @input="patchApplicant({ applicant: { postcode: $event } })" v-validate="'required'" :error-messages="errors.collect('postcode')" :data-vv-as="$t('postcode')" required type="text"></v-text-field>
              <v-select clearable name="city" :value="data.applicant.city" :label="$t('city')"  @input="patchApplicant({ applicant: { city: $event } })" :items="cities[data.applicant.state]" :item-text="opt => opt" :item-value="opt => opt" v-validate="'required'" :error-messages="errors.collect('city')" :data-vv-as="$t('city')"></v-select>
              <div class="text-right">
                <v-btn color="primary" @click="stepnow = 2">{{ $t('continue') }}</v-btn>
              </div>
            </v-card>
          </v-stepper-content>

          <!-- busineess info -->
          <v-stepper-step :complete="stepnow > 2" step="2" @click.native="stepnow > 1 ? stepnow = 2 : null">
            {{ $t('business_information') }}
          </v-stepper-step>

          <v-stepper-content step="2">
            <v-card flat class="mb-12">
              <v-text-field clearable name="business_name" :value="data.business.business_name" :label="$t('business_name')" @input="patchBusiness({ business: { business_name: $event } })" v-validate="'required'" :error-messages="errors.collect('business_name')" :data-vv-as="$t('business_name')" required type="text"></v-text-field>
              <v-textarea clearable name="address" :value="data.business.address" :label="$t('mail_address')" @input="patchBusiness({ business: { address: $event } })" v-validate="'required'" :error-messages="errors.collect('address')" :data-vv-as="$t('address')" required></v-textarea>
              <v-text-field clearable name="postcode" :value="data.business.postcode" :label="$t('postcode')" @input="patchBusiness({ business: { postcode: $event } })" v-validate="'required'" :error-messages="errors.collect('postcode')" :data-vv-as="$t('postcode')" required type="text"></v-text-field>
              <v-text-field clearable disabled name="state" :value="data.business.state" :label="$t('state')" @input="patchBusiness({ business: { state: $event } })" v-validate="'required'" :error-messages="errors.collect('state')" :data-vv-as="$t('state')" required type="text"></v-text-field>
              <v-select clearable name="city" :value="data.business.city" :label="$t('city')"  @input="patchBusiness({ business: { city: $event } })" :items="cities[data.business.state]" :item-text="opt => opt" :item-value="opt => opt" v-validate="'required'" :error-messages="errors.collect('city')" :data-vv-as="$t('city')"></v-select>
              <v-text-field clearable name="phone" :value="data.business.phone" :label="$t('phone')" @input="patchBusiness({ business: { phone: $event } })" v-validate="'required'" :error-messages="errors.collect('phone')" :data-vv-as="$t('phone')" required type="text"></v-text-field>
              <v-text-field clearable name="fax" :value="data.business.fax" :label="$t('fax')" @input="patchBusiness({ business: { fax: $event } })" v-validate="'required'" :error-messages="errors.collect('fax')" :data-vv-as="$t('fax')" required type="text"></v-text-field>
              <v-textarea clearable name="business_location" :value="data.business.business_location" :label="$t('business_location')" @input="patchBusiness({ business: { business_location: $event } })" v-validate="'required'" :error-messages="errors.collect('business_location')" :data-vv-as="$t('business_location')" required></v-textarea>
              <v-switch name="premise" class="mt-4" :label="$t('got_premise')" v-model="data.business.premise" @change="patchBusiness({ business: { premise: $event } })" v-validate="'required'" :error-messages="errors.collect('premise')" :data-vv-as="$t('premise')"></v-switch>

              <div v-if="!!data.business.premise">
                <v-text-field clearable name="assessment_no" :value="data.business.assessment_no" :label="$t('assessment_no')" @input="patchBusiness({ business: { assessment_no: $event } })" v-validate="'required'" :error-messages="errors.collect('assessment_no')" :data-vv-as="$t('assessment_no')" required type="text"></v-text-field>

                <div class="row text-xs-left">
                  <v-btn color="primary" @click="searchData()" :disabled="!data.business.assessment_no">
                    <v-icon class="pr-3">fa-search fa-lg</v-icon>
                    {{ $t('search_assessment') }}
                    </v-btn>
                </div>
                <div v-if="data.business.title_no">
                  <v-text-field clearable name="bumiputera_share" :value="data.business.bumiputera_share" :label="$t('bumiputera_share') + ' (%)'" @input="patchBusiness({ business: { bumiputera_share: $event } })" v-validate="'required|min_value:0.01|max_value:100'" :error-messages="errors.collect('bumiputera_share')" :data-vv-as="$t('bumiputera_share')" step="0.01" required type="number"></v-text-field>
                  <!-- get data from assessment info -->
                  <v-textarea clearable name="area" :value="data.business.area" :label="$t('area')" @input="patchBusiness({ business: { area: $event } })" v-validate="'required'" :error-messages="errors.collect('area')" :data-vv-as="$t('area')" required type="text"></v-textarea>
                  <v-text-field readonly clearable name="title_no" :value="data.business.title_no" :label="$t('title_no') + ' (Tidak Boleh Diubah)'" @input="patchBusiness({ business: { title_no: $event } })" v-validate="'required'" :error-messages="errors.collect('title_no')" :data-vv-as="$t('title_no')" required type="text"></v-text-field>
                  <v-text-field readonly clearable name="payment_needed" :value="data.business.payment_needed" :label="$t('payment_needed') + ' (RM) (Tidak Boleh Diubah)'" @input="patchBusiness({ business: { payment_needed: $event } })" v-validate="'required|min_value:0'" :error-messages="errors.collect('payment_needed')" :data-vv-as="$t('payment_needed')" required type="text"></v-text-field>
                  <!-- <v-text-field disabled clearable name="no_of_trading_on_property" :value="data.business.no_of_trading_on_property" :label="$t('no_of_trading_on_property')" @input="patchBusiness({ business: { no_of_trading_on_property: $event } })" v-validate="'required'" :error-messages="errors.collect('no_of_trading_on_property')" :data-vv-as="$t('no_of_trading_on_property')" required type="text"></v-text-field>
                  <v-text-field disabled clearable name="use_code" :value="data.business.use_code" :label="$t('use_code')" @input="patchBusiness({ business: { use_code: $event } })" v-validate="'required'" :error-messages="errors.collect('use_code')" :data-vv-as="$t('use_code')" required type="text"></v-text-field> -->
                  <!-- <v-text-field disabled clearable name="installment" :value="data.business.installment" :label="$t('installment')" @input="patchBusiness({ business: { installment: $event } })" v-validate="'required'" :error-messages="errors.collect('installment')" :data-vv-as="$t('installment')" required type="text"></v-text-field> -->
                </div>
              </div>

              <v-select name="business_type" class="pt-4" :items="categories" :item-text="opt => opt.name" :item-value="opt => opt._id" v-model="form.business_activity1" :label="$t('business_type')" v-validate="'required'" :error-messages="errors.collect('business_type')" :data-vv-as="$t('business_type')"></v-select>
              <v-select name="business_category" :items="subCategories.filter(row => row.category_id === form.business_activity1)" :item-text="opt => opt.name" :item-value="opt => opt._id" v-model="form.business_activity2" @input="form.business_activity3 = activities.filter(row => row.category_id === form.business_activity1 && row.subcategory_id === form.business_activity2)[0]._id" :label="$t('business_category')" v-validate="'required'" :error-messages="errors.collect('business_category')" :data-vv-as="$t('business_category')"></v-select>
              <v-select
                clearable
                name="business_activity"
                disabled
                v-model="form.business_activity3"
                :label="$t('business_activity')"
                :items="activities"
                :item-text="opt => opt.name"
                :item-value="opt => opt._id"
                >
              </v-select>
              <div class="row text-left ml-2">
                <v-btn color="primary" @click="patchBusinessActivity({ business_activity: form.business_activity3 })" :disabled="!form.business_activity3">
                  <v-icon class="pr-3">fa-plus fa-lg</v-icon>
                  {{ $t('add_business_activity') }}
                </v-btn>
              </div>
              <table id="activity" class="mt-2 ml-2" v-if="data.business.business_activity.length > 0">
                <tr>
                  <th colSpan="2">{{ $t('business_activity') }}</th>
                </tr>
                <tr v-for="(act, index) in data.business.business_activity" :key="index">
                  <td>{{ act }}</td>
                  <td width="20%" class="text-center" @click="removeBusinessActivity({ business_activity: act, index })">
                    <v-btn color="red" text>
                      <v-icon class="pr-3">fa-times fa-lg</v-icon>
                      {{ $t('remove') }}
                    </v-btn>
                  </td>
                </tr>
              </table>

              <div class="text-right pt-5">
                <v-btn outlined color="primary" @click="stepnow = 1">{{ $t('previous') }}</v-btn>
                <v-btn color="primary" @click="stepnow = 3">{{ $t('continue') }}</v-btn>
              </div>
            </v-card>
          </v-stepper-content>

          <!-- council license -->
          <v-stepper-step :complete="stepnow > 3" step="3" @click.native="stepnow > 2 ? stepnow = 3 : null">
            {{ $t('council_license_information') }}
          </v-stepper-step>

          <v-stepper-content step="3">
            <v-card class="pa-5 grey lighten-2 mb-2" flat>
            {{ $t('no_council_license_needed') }}
            </v-card>
            <!-- <v-card class="mb-12" flat v-for="(item, index) in data.council_license" :key="index">
              <v-text-field clearable name="charge_per_unit" :value="item.charge_per_unit" :label="$t('charge_per_unit') + ' (RM)'" @input="patchCouncilLicense({ council_license: { charge_per_unit: $event}, index  })" v-validate="'required|min_value:0'" :error-messages="errors.collect('charge_per_unit')" :data-vv-as="$t('charge_per_unit')" required step="0.01" type="number"></v-text-field>
              <v-text-field clearable name="license_charge" :value="item.license_charge" :label="$t('license_charge') + ' (RM)'" @input="patchCouncilLicense({ council_license: { license_charge: $event }, index })" v-validate="'required|min_value:0'" :error-messages="errors.collect('license_charge')" :data-vv-as="$t('license_charge')" required step="0.01" type="number"></v-text-field>
              <v-text-field clearable name="other_charges" :value="item.other_charges" :label="$t('other_charges') + ' (RM)'" @input="patchCouncilLicense({ council_license: { other_charges: $event }, index })" v-validate="'required|min_value:0'" :error-messages="errors.collect('other_charges')" :data-vv-as="$t('other_charges')" required step="0.01" type="number"></v-text-field>
              <v-text-field clearable name="units" :value="item.units" :label="$t('units')" @input="patchCouncilLicense({ council_license: { units: $event }, index })" v-validate="'required|min_value:0'" :error-messages="errors.collect('units')" :data-vv-as="$t('units')" required step="1" type="number"></v-text-field>
            </v-card> -->

            <div class="text-right">
              <v-btn outlined color="primary" @click="stepnow = 2">{{ $t('previous') }}</v-btn>
              <v-btn color="primary" @click="stepnow = 4">{{ $t('continue') }}</v-btn>
            </div>
          </v-stepper-content>

          <!-- owner -->
          <v-stepper-step :complete="stepnow > 4" step="4" @click.native="stepnow > 3 ? stepnow = 4 : null">
            {{ $t('owner_information') }}
          </v-stepper-step>

          <v-stepper-content step="4">
            <v-card class="mb-12" flat>
              <v-select clearable name="ownership_type" :value="data.owner.ownership_type" :label="$t('ownership_type')"  @input="patchOwner({ owner: { ownership_type: $event } }); switchOwnershipType($event)" :items="ownership_type" :item-text="opt => $t(opt.value)" :item-value="opt => opt.value" v-validate="'required'" :error-messages="errors.collect('ownership_type')" :data-vv-as="$t('ownership_type')"></v-select>

              <div v-if="data.owner.ownership_type === 'sole_proprietor' || data.owner.ownership_type === 'partnership'">
                <v-text-field clearable name="owner_name" :value="data.owner.name" :label="$t('name')" @input="patchOwner({ owner: { name: $event } })" v-validate="'required'" :error-messages="errors.collect('name')" :data-vv-as="$t('name')" required type="text"></v-text-field>
                <v-select clearable name="identity_type" :value="data.owner.identity_type" :label="$t('identity_type')"  @input="patchOwner({ owner: { identity_type: $event } })" :items="identity_type" :item-text="opt => $t(opt.value)" :item-value="opt => opt.value" v-validate="'required'" :error-messages="errors.collect('identity_type')" :data-vv-as="$t('identity_type')"></v-select>
                <v-text-field clearable name="identity_no" :value="data.owner.identity_no" :label="$t('identity_no')" @input="patchOwner({ owner: { identity_no: $event } })" v-validate="'required'" :error-messages="errors.collect('identity_no')" :data-vv-as="$t('identity_no')" required type="text"></v-text-field>
                <!-- <v-text-field clearable name="date_of_birth" :value="data.owner.date_of_birth" :label="$t('date_of_birth')" @input="patchOwner({ owner: { date_of_birth: $event } })" return-masked-value  mask="##/##/####" placeholder="DD/MM/YYYY" v-validate="'required'" :error-messages="errors.collect('date_of_birth')" :data-vv-as="$t('date_of_birth')" required type="text"></v-text-field> -->
                <!-- <v-text-field clearable name="work_pass" :value="data.owner.work_pass" :label="$t('work_pass')" @input="patchOwner({ owner: { work_pass: $event } })" v-validate="'required'" :error-messages="errors.collect('work_pass')" :data-vv-as="$t('work_pass')" required type="text"></v-text-field> -->
                <!-- <v-text-field clearable name="expired_date_of_pass" :value="data.owner.expired_date_of_pass" :label="$t('expired_date_of_pass')" @input="patchOwner({ owner: { expired_date_of_pass: $event } })" return-masked-value  mask="##/##/####" placeholder="DD/MM/YYYY"  v-validate="'required'" :error-messages="errors.collect('expired_date_of_pass')" :data-vv-as="$t('expired_date_of_pass')" required type="text"></v-text-field> -->
                <!-- <v-text-field clearable name="nationality" :value="data.owner.nationality" :label="$t('nationality')" @input="patchOwner({ owner: { nationality: $event } })" v-validate="'required'" :error-messages="errors.collect('nationality')" :data-vv-as="$t('nationality')" required type="text"></v-text-field> -->
                <v-select clearable name="citizenship" :value="data.owner.citizenship" :label="$t('citizenship')"  @input="patchOwner({ owner: { citizenship: $event } })" :items="citizenship" v-validate="'required'" :error-messages="errors.collect('citizenship')" :data-vv-as="$t('citizenship')"></v-select>
                <v-select clearable name="gender" :value="data.owner.gender" :label="$t('gender')"  @input="patchOwner({ owner: { gender: $event } })" :items="gender" :item-text="opt => $t(opt.value).toUpperCase()" :item-value="opt => opt.value"  v-validate="'required'" :error-messages="errors.collect('gender')" :data-vv-as="$t('gender')"></v-select>
                <v-select clearable name="religion" :value="data.owner.religion" :label="$t('religion')"  @input="patchOwner({ owner: { religion: $event } })" :items="religion" v-validate="'required'" :error-messages="errors.collect('religion')" :data-vv-as="$t('religion')"></v-select>
                <v-select clearable name="race" :value="data.owner.race" :label="$t('race')"  @input="patchOwner({ owner: { race: $event } })" :items="race" v-validate="'required'" :error-messages="errors.collect('race')" :data-vv-as="$t('race')"></v-select>
                <v-select clearable name="marital_status" :value="data.owner.marital_status" :label="$t('marital_status')"  @input="patchOwner({ owner: { marital_status: $event } })" :items="marital_status" :item-text="opt => $t(opt.text)" :item-value="opt => opt.value" v-validate="'required'" :error-messages="errors.collect('marital_status')" :data-vv-as="$t('marital_status')"></v-select>
                <v-textarea clearable name="mailing_address" :value="data.owner.mailing_address" :label="$t('mailing_address')" @input="patchOwner({ owner: { mailing_address: $event } })" v-validate="'required'" :error-messages="errors.collect('mailing_address')" :data-vv-as="$t('mailing_address')" required type="text"></v-textarea>
                <v-text-field clearable name="postcode" :value="data.owner.mail_postcode" :label="$t('postcode')" @input="patchOwner({ owner: { mail_postcode: $event } })" v-validate="'required'" :error-messages="errors.collect('postcode')" :data-vv-as="$t('postcode')" required type="text"></v-text-field>
                <v-select clearable name="state" :value="data.owner.mail_state" :label="$t('state')"  @input="patchOwner({ owner: { mail_state: $event } })" :items="states" :item-text="opt => opt" :item-value="opt => opt" v-validate="'required'" :error-messages="errors.collect('state')" :data-vv-as="$t('state')"></v-select>
                <v-select clearable name="city" :value="data.owner.mail_city" :label="$t('city')"  @input="patchOwner({ owner: { mail_city: $event } })" :items="cities[data.owner.mail_state]" :item-text="opt => opt" :item-value="opt => opt" v-validate="'required'" :error-messages="errors.collect('city')" :data-vv-as="$t('city')"></v-select>
                <v-switch name="sameAsMail" class="mt-4" :label="$t('same_as_mail')" v-model="data.owner.sameAsMail" @change="$event ? patchOwner({ owner: { sameAsMail: $event, residential_address: data.owner.mailing_address, postcode: data.owner.mail_postcode, city: data.owner.mail_city } }) : patchBusiness({ owner: { sameAsMail: $event, residential_address: '', postcode: '', city: '' } })"></v-switch>
                <v-textarea clearable name="residential_address" :value="data.owner.residential_address" :label="$t('residential_address')" @input="patchOwner({ owner: { residential_address: $event } })" v-validate="'required'" :error-messages="errors.collect('residential_address')" :data-vv-as="$t('residential_address')" required type="text"></v-textarea>
                <v-text-field clearable name="postcode" :value="data.owner.postcode" :label="$t('postcode')" @input="patchOwner({ owner: { postcode: $event } })" v-validate="'required'" :error-messages="errors.collect('postcode')" :data-vv-as="$t('postcode')" required type="text"></v-text-field>
                <v-select clearable name="state" :value="data.owner.state" :label="$t('state')"  @input="patchOwner({ owner: { state: $event } })" :items="states" :item-text="opt => opt" :item-value="opt => opt" v-validate="'required'" :error-messages="errors.collect('state')" :data-vv-as="$t('state')"></v-select>
                <v-select clearable name="city" :value="data.owner.city" :label="$t('city')"  @input="patchOwner({ owner: { city: $event } })" :items="cities[data.owner.state]" :item-text="opt => opt" :item-value="opt => opt" v-validate="'required'" :error-messages="errors.collect('city')" :data-vv-as="$t('city')"></v-select>
                <v-text-field clearable name="mobile_tel" :value="data.owner.mobile_tel" :label="$t('mobile_tel')" @input="patchOwner({ owner: { mobile_tel: $event } })" v-validate="'required'" :error-messages="errors.collect('mobile_tel')" :data-vv-as="$t('mobile_tel')" required type="tel"></v-text-field>
                <v-text-field clearable name="office_tel" :value="data.owner.office_tel" :label="$t('office_tel')" @input="patchOwner({ owner: { office_tel: $event } })" v-validate="'required'" :error-messages="errors.collect('office_tel')" :data-vv-as="$t('office_tel')" required type="tel"></v-text-field>
                <v-text-field clearable name="residential_tel" :value="data.owner.residential_tel" :label="$t('residential_tel')" @input="patchOwner({ owner: { residential_tel: $event } })" v-validate="'required'" :error-messages="errors.collect('residential_tel')" :data-vv-as="$t('residential_tel')" required type="tel"></v-text-field>
              </div>

              <div v-if="data.owner.ownership_type === 'private_limited_company' || data.owner.ownership_type === 'public_limited_company' || data.owner.ownership_type === 'corporation_company'">
                <v-select clearable name="company_type" :value="data.owner.company_type" :label="$t('company_type')"  @input="patchOwner({ owner: { company_type: $event } })" :items="company_type.filter(row => row.type === 'company')" :item-text="opt => opt.value" :item-value="opt => opt.value" v-validate="'required'" :error-messages="errors.collect('company_type')" :data-vv-as="$t('company_type')"></v-select>
                <v-text-field clearable name="registered_company_name" :value="data.owner.registered_company_name" :label="$t('registered_company_name')" @input="patchOwner({ owner: { registered_company_name: $event } })" v-validate="'required'" :error-messages="errors.collect('registered_company_name')" :data-vv-as="$t('registered_company_name')" required type="text"></v-text-field>
              </div>

              <div v-if="data.owner.ownership_type === 'organization_or_cooperation'">
                <v-select clearable name="company_type" :value="data.owner.company_type" :label="$t('company_type')"  @input="patchOwner({ owner: { company_type: $event } })" :items="company_type.filter(row => row.type === 'organization_or_cooperation')" :item-text="opt => opt.value" :item-value="opt => opt.value" v-validate="'required'" :error-messages="errors.collect('company_type')" :data-vv-as="$t('company_type')"></v-select>
                <v-text-field clearable name="name_of_organization_cooperation" :value="data.owner.name_of_organization_cooperation" :label="$t('name_of_organization_cooperation')" @input="patchOwner({ owner: { name_of_organization_cooperation: $event } })" v-validate="'required'" :error-messages="errors.collect('name_of_organization_cooperation')" :data-vv-as="$t('name_of_organization_cooperation')" required type="text"></v-text-field>
                <v-text-field clearable name="organization_cooperation_field" :value="data.owner.organization_cooperation_field" :label="$t('organization_cooperation_field')" @input="patchOwner({ owner: { organization_cooperation_field: $event } })" v-validate="'required'" :error-messages="errors.collect('organization_cooperation_field')" :data-vv-as="$t('organization_cooperation_field')" required type="text"></v-text-field>
              </div>

              <div v-if="data.owner.ownership_type === 'government'">
               <v-text-field clearable name="name_of_glc" :value="data.owner.name_of_glc" :label="$t('name_of_glc')" @input="patchOwner({ owner: { name_of_glc: $event } })" v-validate="'required'" :error-messages="errors.collect('name_of_glc')" :data-vv-as="$t('name_of_glc')" required type="text"></v-text-field>
              </div>

              <div v-if="data.owner.ownership_type && data.owner.ownership_type !== 'sole_proprietor' && data.owner.ownership_type !== 'partnership'">
                <v-text-field clearable name="register_no" :value="data.owner.register_no" :label="$t('register_no')" @input="patchOwner({ owner: { register_no: $event } })" v-validate="'required'" :error-messages="errors.collect('register_no')" :data-vv-as="$t('register_no')" required type="text"></v-text-field>
                <v-textarea clearable name="mailing_address" :value="data.owner.mailing_address" :label="$t('mailing_address')" @input="patchOwner({ owner: { mailing_address: $event } })" v-validate="'required'" :error-messages="errors.collect('mailing_address')" :data-vv-as="$t('mailing_address')" required type="text"></v-textarea>
                <v-text-field clearable name="postcode" :value="data.owner.mail_postcode" :label="$t('postcode')" @input="patchOwner({ owner: { mail_postcode: $event } })" v-validate="'required'" :error-messages="errors.collect('postcode')" :data-vv-as="$t('postcode')" required type="text"></v-text-field>
                <v-select clearable name="state" :value="data.owner.mail_state" :label="$t('state')"  @input="patchOwner({ owner: { mail_state: $event } })" :items="states" :item-text="opt => opt" :item-value="opt => opt" v-validate="'required'" :error-messages="errors.collect('state')" :data-vv-as="$t('state')"></v-select>
                <v-select clearable name="city" :value="data.owner.mail_city" :label="$t('city')"  @input="patchOwner({ owner: { mail_city: $event } })" :items="cities[data.owner.mail_state]" :item-text="opt => opt" :item-value="opt => opt" v-validate="'required'" :error-messages="errors.collect('city')" :data-vv-as="$t('city')"></v-select>
                <v-switch name="sameAsMail" class="mt-4" :label="$t('same_as_mail')" v-model="data.owner.sameAsMail" @change="$event ? patchOwner({ owner: { sameAsMail: $event, office_address: data.owner.mailing_address, postcode: data.owner.mail_postcode, city: data.owner.mail_city, state: data.owner.mail_state } }) : patchBusiness({ owner: { sameAsMail: $event, office_address: '', postcode: '', city: '', state: '' } })"></v-switch>
                <v-textarea clearable name="office_address" :value="data.owner.office_address" :label="$t('office_address')" @input="patchOwner({ owner: { office_address: $event } })" v-validate="'required'" :error-messages="errors.collect('office_address')" :data-vv-as="$t('office_address')" required type="text"></v-textarea>
                <v-text-field clearable name="postcode" :value="data.owner.postcode" :label="$t('postcode')" @input="patchOwner({ owner: { postcode: $event } })" v-validate="'required'" :error-messages="errors.collect('postcode')" :data-vv-as="$t('postcode')" required type="text"></v-text-field>
                <v-select clearable name="state" :value="data.owner.state" :label="$t('state')"  @input="patchOwner({ owner: { state: $event } })" :items="states" :item-text="opt => opt" :item-value="opt => opt" v-validate="'required'" :error-messages="errors.collect('state')" :data-vv-as="$t('state')"></v-select>
                <v-select clearable name="city" :value="data.owner.city" :label="$t('city')"  @input="patchOwner({ owner: { city: $event } })" :items="cities[data.owner.state]" :item-text="opt => opt" :item-value="opt => opt" v-validate="'required'" :error-messages="errors.collect('city')" :data-vv-as="$t('city')"></v-select>
                <v-text-field clearable name="phone" :value="data.owner.phone" :label="$t('phone')" @input="patchOwner({ owner: { phone: $event } })" v-validate="'required'" :error-messages="errors.collect('phone')" :data-vv-as="$t('phone')" required type="tel"></v-text-field>
                <v-text-field clearable name="fax" :value="data.owner.fax" :label="$t('fax')" @input="patchOwner({ owner: { fax: $event } })" v-validate="'required'" :error-messages="errors.collect('fax')" :data-vv-as="$t('fax')" required type="tel"></v-text-field>
                <v-text-field clearable name="email" :value="data.owner.email" :label="$t('email')" @input="patchOwner({ owner: { email: $event } })" v-validate="'required|email'" :error-messages="errors.collect('email')" :data-vv-as="$t('email')" required type="email"></v-text-field>
                <v-text-field clearable name="homepage" :value="data.owner.homepage" :label="$t('homepage')" @input="patchOwner({ owner: { homepage: $event } })" v-validate="'required'" :error-messages="errors.collect('homepage')" :data-vv-as="$t('homepage')" required type="text"></v-text-field>
              </div>

              <div class="text-right">
                <v-btn outlined color="primary" @click="stepnow = 3">{{ $t('previous') }}</v-btn>
                <v-btn color="primary" @click="stepnow = 5">{{ $t('continue') }}</v-btn>
              </div>
            </v-card>
          </v-stepper-content>

          <!-- manager -->
          <v-stepper-step :complete="stepnow > 5" step="5" @click.native="stepnow > 4 ? stepnow = 5 : null">
            {{ $t('manager_information') }}
          </v-stepper-step>

          <v-stepper-content step="5">
            <v-card class="mb-12" flat>
              <v-switch v-if="data.owner.ownership_type ==='sole_proprietor' || data.owner.ownership_type ==='partnership'" v-model="switchManager" @change="$event ? patchManager({ manager: data.owner }) : resetManager()" :label="$t('same_with_owner_information')"></v-switch>
              <div v-if="!switchManager || (data.owner.ownership_type !=='sole_proprietor' && data.owner.ownership_type !=='partnership')">
                <v-text-field clearable name="manager_name" :value="data.manager.name" :label="$t('name')" @input="patchManager({ manager: { name: $event } })" v-validate="'required'" :error-messages="errors.collect('name')" :data-vv-as="$t('name')" required type="text"></v-text-field>
                <v-select clearable name="identity_type" :value="data.manager.identity_type" :label="$t('identity_type')"  @input="patchManager({ manager: { identity_type: $event } })" :items="identity_type" :item-text="opt => $t(opt.value)" :item-value="opt => opt.value" v-validate="'required'" :error-messages="errors.collect('identity_type')" :data-vv-as="$t('identity_type')"></v-select>
                <v-text-field clearable name="identity_no" :value="data.manager.identity_no" :label="$t('identity_no')" @input="patchManager({ manager: { identity_no: $event } })" :counter="15" v-validate="'required'" :error-messages="errors.collect('identity_no')" :data-vv-as="$t('identity_no')" required type="text"></v-text-field>
                <!-- <v-text-field clearable name="date_of_birth" :value="data.manager.date_of_birth" :label="$t('date_of_birth')" @input="patchManager({ manager: { date_of_birth: $event } })" return-masked-value  mask="##/##/####" placeholder="DD/MM/YYYY" v-validate="'required'" :error-messages="errors.collect('date_of_birth')" :data-vv-as="$t('date_of_birth')" required type="text"></v-text-field>
                <v-text-field clearable name="work_pass" :value="data.manager.work_pass" :label="$t('work_pass')" @input="patchManager({ manager: { work_pass: $event } })"  v-validate="'required'" :error-messages="errors.collect('work_pass')" :data-vv-as="$t('work_pass')" required type="text"></v-text-field>
                <v-text-field clearable name="expired_date_of_pass" :value="data.manager.expired_date_of_pass" :label="$t('expired_date_of_pass')" @input="patchManager({ manager: { expired_date_of_pass: $event } })" return-masked-value  mask="##/##/####" placeholder="DD/MM/YYYY" v-validate="'required'" :error-messages="errors.collect('expired_date_of_pass')" :data-vv-as="$t('expired_date_of_pass')" required type="text"></v-text-field> -->
                <!-- <v-text-field clearable name="nationality" :value="data.manager.nationality" :label="$t('nationality')" @input="patchManager({ manager: { nationality: $event } })" v-validate="'required'" :error-messages="errors.collect('nationality')" :data-vv-as="$t('nationality')" required type="text"></v-text-field> -->
                <v-select clearable name="citizenship" :value="data.manager.citizenship" :label="$t('citizenship')"  @input="patchManager({ manager: { citizenship: $event } })" :items="citizenship" v-validate="'required'" :error-messages="errors.collect('citizenship')" :data-vv-as="$t('citizenship')"></v-select>
                <v-select clearable name="gender" :value="data.manager.gender" :label="$t('gender')"  @input="patchManager({ manager: { gender: $event } })" :items="gender" :item-text="opt => $t(opt.value).toUpperCase()" :item-value="opt => opt.value"  v-validate="'required'" :error-messages="errors.collect('gender')" :data-vv-as="$t('gender')"></v-select>
                <v-select clearable name="religion" :value="data.manager.religion" :label="$t('religion')"  @input="patchManager({ manager: { religion: $event } })" :items="religion" v-validate="'required'" :error-messages="errors.collect('religion')" :data-vv-as="$t('religion')"></v-select>
                <v-select clearable name="race" :value="data.manager.race" :label="$t('race')"  @input="patchManager({ manager: { race: $event } })" :items="race" v-validate="'required'" :error-messages="errors.collect('race')" :data-vv-as="$t('race')"></v-select>
                <v-select clearable name="marital_status" :value="data.manager.marital_status" :label="$t('marital_status')"  @input="patchManager({ manager: { marital_status: $event } })" :items="marital_status" :item-text="opt => $t(opt.text)" :item-value="opt => opt.value" v-validate="'required'" :error-messages="errors.collect('marital_status')" :data-vv-as="$t('marital_status')"></v-select>
                <v-textarea clearable name="mailing_address" :value="data.manager.mailing_address" :label="$t('mailing_address')" @input="patchManager({ manager: { mailing_address: $event } })" v-validate="'required'" :error-messages="errors.collect('mailing_address')" :data-vv-as="$t('mailing_address')" required type="text"></v-textarea>
                <v-text-field clearable name="postcode" :value="data.manager.mail_postcode" :label="$t('postcode')" @input="patchManager({ manager: { mail_postcode: $event } })" v-validate="'required'" :error-messages="errors.collect('postcode')" :data-vv-as="$t('postcode')" required type="text"></v-text-field>
                <v-select clearable name="state" :value="data.manager.mail_state" :label="$t('state')"  @input="patchManager({ manager: { mail_state: $event } })" :items="states" :item-text="opt => opt" :item-value="opt => opt" v-validate="'required'" :error-messages="errors.collect('state')" :data-vv-as="$t('state')"></v-select>
                <v-select clearable name="city" :value="data.manager.mail_city" :label="$t('city')"  @input="patchManager({ manager: { mail_city: $event } })" :items="cities[data.manager.mail_state]" :item-text="opt => opt" :item-value="opt => opt" v-validate="'required'" :error-messages="errors.collect('city')" :data-vv-as="$t('city')"></v-select>
                <v-switch name="sameAsMail" class="mt-4" :label="$t('same_as_mail')" v-model="data.manager.sameAsMail" @change="$event ? patchManager({ manager: { sameAsMail: $event, residential_address: data.manager.mailing_address, postcode: data.manager.mail_postcode, city: data.manager.mail_city, state: data.manager.mail_state } }) : patchManager({ manager: { sameAsMail: $event, residential_address: '', postcode: '', city: '', state: '' } })"></v-switch>
                <v-textarea clearable name="residential_address" :value="data.manager.residential_address" :label="$t('residential_address')" @input="patchManager({ manager: { residential_address: $event } })" v-validate="'required'" :error-messages="errors.collect('residential_address')" :data-vv-as="$t('residential_address')" required type="text"></v-textarea>
                <v-text-field clearable name="postcode" :value="data.manager.postcode" :label="$t('postcode')" @input="patchManager({ manager: { postcode: $event } })" v-validate="'required'" :error-messages="errors.collect('postcode')" :data-vv-as="$t('postcode')" required type="text"></v-text-field>
                <v-select clearable name="state" :value="data.manager.state" :label="$t('state')"  @input="patchManager({ owner: { state: $event } })" :items="states" :item-text="opt => opt" :item-value="opt => opt" v-validate="'required'" :error-messages="errors.collect('state')" :data-vv-as="$t('state')"></v-select>
                <v-select clearable name="city" :value="data.manager.city" :label="$t('city')"  @input="patchManager({ owner: { city: $event } })" :items="cities[data.manager.state]" :item-text="opt => opt" :item-value="opt => opt" v-validate="'required'" :error-messages="errors.collect('city')" :data-vv-as="$t('city')"></v-select>
                <v-text-field clearable name="mobile_tel" :value="data.manager.mobile_tel" :label="$t('mobile_tel')" @input="patchManager({ manager: { mobile_tel: $event } })" v-validate="'required'" :error-messages="errors.collect('mobile_tel')" :data-vv-as="$t('mobile_tel')" required type="text"></v-text-field>
                <v-text-field clearable name="office_tel" :value="data.manager.office_tel" :label="$t('office_tel')" @input="patchManager({ manager: { office_tel: $event } })" v-validate="'required'" :error-messages="errors.collect('office_tel')" :data-vv-as="$t('office_tel')" required type="text"></v-text-field>
                <v-text-field clearable name="residential_tel" :value="data.manager.residential_tel" :label="$t('residential_tel')" @input="patchManager({ manager: { residential_tel: $event } })" v-validate="'required'" :error-messages="errors.collect('residential_tel')" :data-vv-as="$t('residential_tel')" required type="text"></v-text-field>
              </div>
              <div class="text-right">
                <v-btn outlined color="primary" @click="stepnow = 4">{{ $t('previous') }}</v-btn>
                <v-btn color="primary" @click="submitForm">{{ $t('submit') }}</v-btn>
                <!-- <v-btn color="primary" class="white--text" @click="print">{{ $t('page_license.print') }}</v-btn> -->
              </div>
            </v-card>
          </v-stepper-content>
        </v-stepper>
      </v-flex>
      <v-overlay :value="loading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-layout>
  </v-container>
</template>

<script>
/* eslint-disable camelcase */
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import i18n from '../../i18n'
import { throttle } from 'lodash'

export default {
  beforeMount: async function () {
    await this.resetData()
    await this.fetchActivities()
    if (this.hasSession()) {
      const { name, full_name, phone, ic_num } = this.$store.state.auth.session
      this.patchApplicant({ applicant: { name: full_name, identity_no: ic_num, identity_type: 'nric', phone, email: name } })
    }
  },
  computed: {
    ...mapState({
      activities: (state) => state.tradingForm.activities,
      categories: (state) => state.tradingForm.categories,
      subCategories: (state) => state.tradingForm.subCategories,
      data: (state) => state.tradingForm.data,
      items1: (state) => state.tradingForm.items1,
      items2: (state) => state.tradingForm.items2,
      items3: (state) => state.tradingForm.items3
    })
  },
  created: async function () {
    await this.$store.dispatch('auth/session')
    if (this.hasSession()) {
      const { name, full_name, phone, ic_num } = this.$store.state.auth.session
      this.patchApplicant({ applicant: { name: full_name, identity_no: ic_num, identity_type: 'nric', phone, email: name } })
    }
    window.scrollTo(0, 0)
  },
  data () {
    return {
      date: new Date().toISOString().substr(0, 10),
      dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      loading: false,
      menu1: false,
      menu2: false,
      switchPremise: true,
      switchManager: false,
      stepnow: 1,
      form: {
        business_activity1: '',
        business_activity2: '',
        business_activity3: ''
      },
      company_type: [
        { value: 'The Registrar of Cos', type: 'company' },
        { value: 'Wholly Owned By', type: 'company' },
        { value: 'Organization', type: 'organization_or_cooperation' },
        { value: 'Coorperation', type: 'organization_or_cooperation' }
      ],
      marital_status: [
        { text: 'single', value: 'single' },
        { text: 'married', value: 'married' },
        { text: 'widow', value: 'widow' },
        { text: 'widower', value: 'widower' },
        { text: 'single_mother', value: 'single_mother' },
        { text: 'single_father', value: 'single_father' }
      ],
      identity_type: [
        { value: 'nric' },
        { value: 'oldic' },
        { value: 'passport' }
      ],
      gender: [
        { value: 'male' },
        { value: 'female' }
      ],
      citizenship: [
        'MALAYSIAN - SABAH',
        'MALAYSIAN - SARAWAK / SEMENANJUNG MALAYSIA',
        'PEMASTAUTIN / PEMEGANG PERMIT TINGGAL TETAP',
        'OTHERS'
      ],
      ownership_type: [
        { value: 'sole_proprietor' },
        { value: 'partnership' },
        { value: 'private_limited_company' },
        { value: 'public_limited_company' },
        { value: 'corporation_company' },
        { value: 'organization_or_cooperation' },
        { value: 'government' }
      ],
      religion: [
        'ISLAM',
        'BUDDHIST',
        'CHRISTIAN',
        'HINDU',
        'OTHERS'
      ],
      race: [
        'ARABIAN',
        'BAJAU',
        'BANJAR',
        'BATAK',
        'BISAYA',
        'BOLONGAN',
        'BRUNEI',
        'BUGIS',
        'BUTON',
        'CHINESE',
        'DUSUN',
        'EAU',
        'IBAN',
        'INDIAN',
        'JAWA',
        'KADAZAN',
        'MELAYU',
        'MINANG',
        'MURUT',
        'PAKISTAN',
        'SAB',
        'SIN',
        'SULUK',
        'TATOR',
        'TIDUNG',
        'TIMORESE',
        'TORAJA',
        'VISAYA',
        'OTHERS'
      ],
      states: [
        'Johor',
        'Kedah',
        'Kelantan',
        'Melaka',
        'Negeri Sembilan',
        'Pahang',
        'Perak',
        'Perlis',
        'Pulau Pinang',
        'Sarawak',
        'Selangor',
        'Terengganu',
        'Kuala Lumpur',
        'Labuan',
        'Sabah',
        'Putrajaya'
      ],
      cities: {
        'Johor': [
          'Johor Bahru',
          'Tebrau',
          'Pasir Gudang',
          'Bukit Indah',
          'Skudai',
          'Kluang',
          'Batu Pahat',
          'Muar',
          'Ulu Tiram',
          'Senai',
          'Segamat',
          'Kulai',
          'Kota Tinggi',
          'Pontian Kechil',
          'Tangkak',
          'Bukit Bakri',
          'Yong Peng',
          'Pekan Nenas',
          'Labis',
          'Mersing',
          'Simpang Renggam',
          'Parit Raja',
          'Kelapa Sawit',
          'Buloh Kasap',
          'Chaah'
        ],
        'Kedah': [
          'Sungai Petani',
          'Alor Setar',
          'Kulim',
          'Jitra / Kubang Pasu',
          'Baling',
          'Pendang',
          'Langkawi',
          'Yan',
          'Sik',
          'Kuala Nerang',
          'Pokok Sena',
          'Bandar Baharu'
        ],
        'Kelantan': [
          'Kota Bharu',
          'Pangkal Kalong',
          'Tanah Merah',
          'Peringat',
          'Wakaf Baru',
          'Kadok',
          'Pasir Mas',
          'Gua Musang',
          'Kuala Krai',
          'Tumpat'
        ],
        'Melaka': [
          'Bandaraya Melaka',
          'Bukit Baru',
          'Ayer Keroh',
          'Klebang',
          'Masjid Tanah',
          'Sungai Udang',
          'Batu Berendam',
          'Alor Gajah',
          'Bukit Rambai',
          'Ayer Molek',
          'Bemban',
          'Kuala Sungai Baru',
          'Pulau Sebang'
        ],
        'Negeri Sembilan': [
          'Seremban',
          'Port Dickson',
          'Nilai',
          'Bahau',
          'Tampin',
          'Kuala Pilah'
        ],
        'Pahang': [
          'Kuantan',
          'Temerloh',
          'Bentong',
          'Mentakab',
          'Raub',
          'Jerantut',
          'Pekan',
          'Kuala Lipis',
          'Bandar Jengka',
          'Bukit Tinggi'
        ],
        'Perak': [
          'Ipoh',
          'Taiping',
          'Sitiawan',
          'Simpang Empat',
          'Teluk Intan',
          'Batu Gajah',
          'Lumut',
          'Kampung Koh',
          'Kuala Kangsar',
          'Sungai Siput Utara',
          'Tapah',
          'Bidor',
          'Parit Buntar',
          'Ayer Tawar',
          'Bagan Serai',
          'Tanjung Malim',
          'Lawan Kuda Baharu',
          'Pantai Remis',
          'Kampar'
        ],
        'Perlis': [
          'Kangar',
          'Kuala Perlis'
        ],
        'Pulau Pinang': [
          'Bukit Mertajam',
          'Georgetown',
          'Sungai Ara',
          'Gelugor',
          'Ayer Itam',
          'Butterworth',
          'Val d’Or',
          'Perai',
          'Nibong Tebal',
          'Permatang Kucing',
          'Tanjung Tokong',
          'Kepala Batas',
          'Tanjung Bungah',
          'Juru'
        ],
        'Sabah': [
          'Kota Kinabalu',
          'Sandakan',
          'Tawau',
          'Lahad Datu',
          'Keningau',
          'Putatan',
          'Donggongon',
          'Semporna',
          'Kudat',
          'Kunak',
          'Papar',
          'Ranau',
          'Beaufort',
          'Kinarut',
          'Kota Belud'
        ],
        'Sarawak': [
          'Kuching',
          'Miri',
          'Sibu',
          'Bintulu',
          'Limbang',
          'Sarikei',
          'Sri Aman',
          'Kapit',
          'Batu Delapan Bazaar',
          'Kota Samarahan'
        ],
        'Selangor': [
          'Subang Jaya',
          'Klang',
          'Ampang Jaya',
          'Shah Alam',
          'Petaling Jaya',
          'Cheras',
          'Kajang',
          'Selayang Baru',
          'Rawang',
          'Taman Greenwood',
          'Semenyih',
          'Banting',
          'Balakong',
          'Gombak Setia',
          'Kuala Selangor',
          'Serendah',
          'Bukit Beruntung',
          'Pengkalan Kundang',
          'Jenjarom',
          'Sungai Besar',
          'Batu Arang',
          'Tanjung Sepat',
          'Kuang',
          'Kuala Kubu Baharu',
          'Batang Berjuntai',
          'Bandar Baru Salak Tinggi',
          'Sekinchan',
          'Sabak',
          'Tanjung Karang',
          'Beranang',
          'Sungai Pelek'
        ],
        'Terengganu': [
          'Kuala Terengganu',
          'Chukai',
          'Dungun',
          'Kerteh',
          'Kuala Berang',
          'Marang',
          'Paka',
          'Jerteh'
        ],
        'Wilayah Persekutuan': [
          'Kuala Lumpur',
          'Labuan',
          'Putrajaya'
        ]
      }
    }
  },
  methods: {
    ...mapGetters({
      hasSession: 'auth/hasSession'
    }),
    ...mapActions({
      searchData: 'tradingForm/searchData',
      fetchActivities: 'tradingForm/fetchActivities',
      submitData: 'tradingForm/submitData'
    }),
    ...mapMutations({
      resetData: 'tradingForm/resetData',
      resetManager: 'tradingForm/resetManager',
      resetOwner: 'tradingForm/resetOwner',
      setData: 'tradingForm/setData',
      patchApplicant: 'tradingForm/patchApplicant',
      patchBusiness: 'tradingForm/patchBusiness',
      patchBusinessActivity: 'tradingForm/patchBusinessActivity',
      removeBusinessActivity: 'tradingForm/removeBusinessActivity',
      patchCouncilLicense: 'tradingForm/patchCouncilLicense',
      patchOwner: 'tradingForm/patchOwner',
      patchManager: 'tradingForm/patchManager'
    }),
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    async switchOwnershipType (value) {
      let ownership_type = this.data.owner.ownership_type
      if (ownership_type === 'sole_proprietor' || ownership_type === 'partnership') {
        await this.resetOwner()
        this.patchOwner({ owner: { ownership_type, nationality: 'MALAYSIAN' } })
      } else {
        await this.resetOwner()
        this.patchOwner({ owner: { ownership_type } })
      }
    },
    submitForm: throttle(async function ($event) {
      this.loading = true
      if (!(await this.$validator.validateAll()) || this.data.business.business_activity.length < 1) {
        if (!(await this.$validator.validateAll())) {
          this.$store.dispatch('snackbar/setSnackBar', {
            color: 'red',
            message: i18n.t('incomplete_form'),
            visible: true
          })
        }
        if (await this.$validator.validateAll() && this.data.business.business_activity.length < 1) {
          this.$store.dispatch('snackbar/setSnackBar', {
            color: 'red',
            message: i18n.t('please_add_business_activity'),
            visible: true
          })
        }
        this.loading = false
        return
      }
      const response = await this.submitData()
      this.loading = false
      if (response) {
        if (response.ok) {
          this.$router.push(`/trading/preview/${btoa(response.id)}`)
        }
      }
    }, 1000)
  }
}
</script>

<style>
#activity {
  /* font-family: "Trebuchet MS", Arial, Helvetica, sans-serif; */
  border-collapse: collapse;
  width: 100%;
}

#activity td, #activity th {
  border: 1px solid #ddd;
  padding: 8px;
}

#activity tr:nth-child(even){background-color: #f2f2f2;}

#activity tr:hover {background-color: #ddd;}

#activity th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #4CAF50;
  color: white;
}
</style>
